import React, { useMemo } from "react"
import { Card, CardBody, CardTitle, Badge } from "reactstrap"
import { Link } from "react-router-dom"
import { useGetAllClientLeadsQuery } from "store/features/clientLeads/clientLeadsManagement"

const HighPriorityLeads = () => {
  const { data: clientLeads = [] } = useGetAllClientLeadsQuery()

  // Filter high priority leads (priority_status = "1")
  const highPriorityLeads = useMemo(() => {
    return clientLeads.filter(lead => lead.priority_status === "1")
  }, [clientLeads])

  // Get priority badge color
  const getPriorityBadge = priority => {
    switch (priority) {
      case "1":
        return <Badge color="danger">High</Badge>
      case "2":
        return <Badge color="warning">Medium</Badge>
      case "3":
        return <Badge color="success">Low</Badge>
      default:
        return <Badge color="secondary">Not Set</Badge>
    }
  }

  // Get status badge color
  const getStatusBadge = status => {
    const statusConfig = {
      "Not received": "secondary",
      Busy: "warning",
      "Sent demo": "info",
      "Sent proposal": "primary",
      "Wanna visit office": "success",
      "Wanna zoom meeting": "success",
      "Sent proposal but no response": "warning",
      "Sent demo, he will review and back to us": "info",
      "Knocked by mistake": "danger",
      "He has low budget": "warning",
      "He will knock us when he need": "info",
    }
    return <Badge color={statusConfig[status] || "secondary"}>{status}</Badge>
  }

  return (
    <Card className="dashboard-card">
      <CardBody>
        <CardTitle tag="h5" className="mb-3">
          High Priority Leads
          <Badge color="danger" className="ms-2">
            {highPriorityLeads.length}
          </Badge>
        </CardTitle>

        {highPriorityLeads.length === 0 ? (
          <div className="text-center py-4">
            <i className="fas fa-exclamation-triangle fa-2x text-muted mb-2"></i>
            <p className="text-muted mb-0">No high priority leads</p>
          </div>
        ) : (
          <div className="high-priority-leads-list">
            {highPriorityLeads.map(lead => (
              <div key={lead.id} className="lead-item mb-3 p-3 border rounded">
                {/* Lead Header */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <a href={`/leads/${lead?.id}`}>
                      <h6 className="mb-1 text-dark">{lead.name}</h6>
                    </a>
                    {/* <small className="text-muted">Contact: {lead.name}</small> */}
                  </div>
                  {getPriorityBadge(lead.priority_status)}
                </div>

                {/* Lead Details */}
                {/* <div className="mb-2">
                  <small className="text-muted">Service: </small>
                  <span className="fw-semibold">{lead.service_name}</span>
                </div>

                <div className="mb-2">
                  <small className="text-muted">Status: </small>
                  {getStatusBadge(lead.status)}
                </div>

                <div className="mb-2">
                  <small className="text-muted">Email: </small>
                  <span className="fw-semibold">{lead.email}</span>
                </div>

                <div className="mb-2">
                  <small className="text-muted">Phone: </small>
                  <span className="fw-semibold">{lead.phone}</span>
                </div> */}

                {/* Requirements Preview */}
                {/* {lead.requirements && (
                  <div className="mb-2">
                    <small className="text-muted">Requirements: </small>
                    <div className="mt-1 small text-dark">
                      {lead.requirements.length > 100
                        ? `${lead.requirements.substring(0, 100)}...`
                        : lead.requirements}
                    </div>
                  </div>
                )} */}

                {/* Timeline Info */}
                {/* <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                  <small className="text-muted">
                    {lead.start_date
                      ? new Date(lead.start_date).toLocaleDateString()
                      : "No start date"}
                  </small>
                  <Link
                    to={`/client-leads/${lead.id}`}
                    className="btn btn-outline-primary btn-sm"
                  >
                    View Details
                  </Link>
                </div> */}

                {/* Follow Up Info */}
                {/* {lead.follow_up_date && (
                  <div className="mt-2 p-2 bg-warning bg-soft rounded">
                    <small className="text-warning fw-semibold">
                      <i className="fas fa-bell me-1"></i>
                      Follow up:{" "}
                      {new Date(lead.follow_up_date).toLocaleDateString()}
                      {lead.follow_up_time && ` at ${lead.follow_up_time}`}
                    </small>
                  </div>
                )} */}
              </div>
            ))}
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default HighPriorityLeads
